import { Component, OnInit, AfterViewInit, ViewChild, OnDestroy, ElementRef } from "@angular/core";
import { AssetsService } from "./asset.services";
import { AssetSortField } from "./asset-sort.enum";
import { DropdownValue } from "../shared/dropdown.model";
import { PageSizeSelectionComponent } from "../shared/page-size-selection.component";
import { NotificationService } from "../core/services";
import { SortService } from '../shared/sort.service';
import { IAssetViewModel } from "./asset.model";
import { SortModel } from "../shared/sort.model";
import { AssetFilterModel } from "./asset-filter.model";
import { AssetFilterComponent } from "./asset-filter.component";
import { CustomHorizontalScrollService } from "../shared/custom-horizontal-scroll.service";
import { FilterItemsService } from "../reports";

@Component({
  moduleId: module.id,
  templateUrl: "asset.component.html",
})
export class AssetComponent implements OnInit, AfterViewInit, OnDestroy {
  data: IAssetViewModel[]
  errorMessage: string;
  pageNumber: number = 1;
  totalCount: number;
  pageSize: number = 0;
  showOverlay: boolean;

  nameSort: SortModel = new SortModel(AssetSortField.Name, SortModel.ascIcon);
  publisherSort: SortModel = new SortModel(AssetSortField.Publisher, SortModel.disabledIcon);
  videoUrlSort: SortModel = new SortModel(AssetSortField.VideoUrl, SortModel.disabledIcon);
  processingStatusSort: SortModel = new SortModel(AssetSortField.ProcessingStatus, SortModel.disabledIcon);

  useLightClass: boolean = true;
  showPublishers: boolean = false;
  showProviders: boolean = false;
  private filters: AssetFilterModel;
  private sortField: SortModel;
  private sortDirectionAsc: boolean = true;
  private inXhrGetAssets: any;

  @ViewChild("pageSizeSelection") pageSizeSelectionComponent: PageSizeSelectionComponent
  @ViewChild("assetFilter") asssetFilterComponent: AssetFilterComponent

  constructor(private assetService: AssetsService,
    private scrollService: CustomHorizontalScrollService,
    private sortService: SortService,
    private filterItemsService: FilterItemsService,
    private notificationService: NotificationService) { }

  ngOnInit() {
    this.sortField = this.nameSort;
    this.showPublishers = this.filterItemsService.getPublishersIds().length >= 1;
    this.showProviders = this.filterItemsService.getProvidersIds().length > 1;
  }

  public getAssets(page: number): void {
    this.asssetFilterComponent.disable();
    if (this.inXhrGetAssets) {
      this.inXhrGetAssets.unsubscribe();
    }
    this.showOverlay = true;
    this.inXhrGetAssets = this.assetService.getFilteredAssets(this.sortField.fieldId, this.sortDirectionAsc, page, this.pageSize, this.filters.name, this.filters.publisherIds)
      .subscribe((res: any) => {
        this.totalCount = res.json().total;
        this.pageNumber = page;
        this.data = <Array<IAssetViewModel>>res.json().data;
      }, error => this.errorMessage = error, () => this.onCompletedGetAssets());
  }

  private onCompletedGetAssets(): void {
    this.showOverlay = false;
    this.asssetFilterComponent.enable();
    this.toggleHorizontalScroll();
  }

  onResize(event) {
    this.toggleHorizontalScroll();
  }

  private toggleHorizontalScroll() {
    let self = this;
    setTimeout(function () {
      self.scrollService.toggleHorizontalScroll();
    }, 10);
  }

  onSortChanged(sort: SortModel) {
    let sortResult = this.sortService.toggleTableColumnSort(this.sortField, this.sortDirectionAsc, sort);
    this.sortField = sortResult.existingSortModel;
    sort = sortResult.selectedSortModel;
    this.sortDirectionAsc = sortResult.sortDiresctionAsc;
    this.getAssets(1);
  }

  onPageSizeChanged(item: DropdownValue) {
    this.pageSize = item.value;
    this.pageNumber = 1;
    this.getAssets(this.pageNumber);
  }

  ngAfterViewInit() {
    this.pageSize = this.pageSizeSelectionComponent.defaultPageSizeSelection.value;
    this.getAssets(1);
    // tree select init
    $("#publishers-select").treeMultiselect({ enableSelectAll: true, sortable: false });
  }

  filter(filters: AssetFilterModel) {
    this.filters = filters;
    if (this.pageSizeSelectionComponent && this.pageSize)
      this.getAssets(1);
  }

  onAssetCreated() {
    this.notificationService.showInfo('Your asset has been successfully uploaded.');
    this.getAssets(1);
  }

  ngOnDestroy() {
    if (this.inXhrGetAssets) {
      this.inXhrGetAssets.unsubscribe();
    }
    this.scrollService.toggleHorizontalScroll(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/assets/asset.component.ts